const principles = [
  {
    quote: "Markets move on interpretation and uncertainty.",
    detail:
      "Price action follows narrative, not just fundamentals. Aegis Vol captures the interpretation layer between raw events and market movement.",
  },
  {
    quote: "Most retail losses come from choosing the wrong structure.",
    detail:
      "Buying calls in a two-sided vol event, selling puts before earnings — structure choice matters as much as direction. Playbook routing solves this.",
  },
  {
    quote: "Avoiding bad trades is profitable.",
    detail:
      "STAND_DOWN is not a failure state. It's the system working. Discipline in filtering low-quality signals is the edge.",
  },
  {
    quote: "Deterministic logic gates LLM usage.",
    detail:
      "LLMs are powerful but unpredictable. The scoring engine is pure rule-based logic. LLMs are invoked only when determinism has already certified a signal is worth analyzing.",
  },
  {
    quote: "Everything must be auditable.",
    detail:
      "Every raw input, score, classification, routing decision, and trade intent is logged. Any outcome can be replayed and explained.",
  },
];

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      className="py-24 sm:py-32 border-t border-navy-700/60"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-huskly-teal mb-4">
            Core Philosophy
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Principles, Not Predictions
          </h2>
          <p className="mt-4 text-slate-400 leading-relaxed">
            Aegis Vol does not predict prices. It doesn't compete on latency. It
            provides structured intelligence about whether a trade is worth
            taking — and what structure to use.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {principles.map((p, i) => (
            <div
              key={i}
              className="rounded-xl border border-navy-700 bg-navy-800/30 p-6 flex flex-col gap-3"
            >
              <p className="text-white font-semibold leading-snug">
                "{p.quote}"
              </p>
              <p className="text-sm text-slate-400 leading-relaxed">
                {p.detail}
              </p>
            </div>
          ))}
        </div>

        {/* Non-goals callout */}
        <div className="mt-12 mx-auto max-w-3xl rounded-xl border border-navy-700 bg-navy-800/20 p-6">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
            Intentional Non-Goals
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              "Price direction prediction",
              "Competing on institutional latency",
              "Fully automated portfolio management",
              "High-frequency trading",
              "Crypto, futures, or FX",
              "Sub-second execution optimization",
            ].map((ng) => (
              <div
                key={ng}
                className="flex items-center gap-2 text-sm text-slate-500"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="h-4 w-4 text-slate-700 shrink-0"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                {ng}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
